/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {TabModel} from '../../../../../../models'
import {RoomModel} from '../../models'
import {getListRoomsExcelService, getRoomsService} from '../../services'
import {getMasterModuleService} from '../../../modules/services'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {SiteModel, CompanyModel, CampModel, ClientModel} from '../../../../../central/model'
import {FormMasiveUploadRoom} from '../Forms/FormMasiveUploadRoom'
import {getSite, getClient, getCompany, getCamp} from '../../../../../central/services'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import moment from 'moment'
import {useModules} from '../../../../hooks/useModules'
import {useCentralServices} from '../../../../hooks/useCentralServices'

interface SelectOption {
  value: string | number | undefined
  label: string | undefined
}

const TableRooms: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {changeCurrentTabItem, currentTabItem, isAllowed} = useHoteleria()

  const {searchValues, changeSearchValues, clearSearchValues} = useKhipu()
  const [level, setLevel] = useState<SelectOption[]>([])
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSite] = useState<SelectOption[]>([])
  const [camp, setCamp] = useState<SelectOption[]>([])
  const [roomType, setRoomType] = useState<SelectOption[]>([])
  const [statusRoom, setStatusRoom] = useState<SelectOption[]>([])
  const [subStatusRoom, setSubStatusRoom] = useState<SelectOption[]>([])
  const [typeModules, setTypeModules] = useState<SelectOption[]>([])
  const [turns, setTurns] = useState<SelectOption[]>([{value: '', label: 'CUALQUIERA'}])
  const [cargos, setCargos] = useState<SelectOption[]>([])
  const [receptionistComp, setReceptionistComp] = useState<SelectOption[]>([
    {value: 'CUALQUIERA', label: 'CUALQUIERA'},
  ])

  const {getTypeModules} = useModules()
  const {getMasterTable, getReceptionist} = useCentralServices()

  const getSiteList = async () => {
    let obj: SiteModel = {
      isCombo: true,
      // clienteId: id,
    }
    const response = await getSite(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setSite(mappedSites)
  }
  const getCampList = async () => {
    let obj: CampModel = {
      isCombo: true,
      // siteId: id,
    }
    const response = await getCamp(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setCamp(mappedSites)
  }
  const getCompanyList = async () => {
    let obj: CompanyModel = {
      isCombo: true,
    }
    const response = await getCompany(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombreEmpresa}))
    setCompany(mappedSites)
  }
  const getClientList = async () => {
    //await new Promise(resolve => setTimeout(resolve, 2000));
    let obj: ClientModel = {
      isCombo: true,
    }
    const response = await getClient(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setClient(mappedSites)
  }
  const getRoomsType = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoHabitacion',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setRoomType(mappedMaster)
    } catch (error) {
      setRoomType([])
    }
  }

  const getTypeModulesFn = async () => {
    const data = await getTypeModules()
    setTypeModules(data)
  }

  const getStatusRoom = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoHabitacion',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
        codigo: master.codigo,
      }))
      setStatusRoom(mappedMaster)
    } catch (error) {
      setStatusRoom([])
    }
  }

  const getSubStatusRoom = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'SubEstadoHabitacion',
      })
      const data = response.data.data || []
      const mappedMaster = data?.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setSubStatusRoom(mappedMaster)
    } catch (error) {
      setSubStatusRoom([])
    }
  }
  const getLevels = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'Nivel',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setLevel(mappedMaster)
    } catch (error) {
      setLevel([])
    }
  }

  const getTurnsFn = async () => {
    const data = await getMasterTable('Turno', true)
    const allData = [{value: '', label: 'CUALQUIERA'}, ...data]
    setTurns(allData)
  }

  const getCargosFn = async () => {
    const data = await getMasterTable('Cargo', true)
    const allData = [{value: '', label: 'CUALQUIERA'}, ...data]
    setCargos(allData)
  }

  const getReceptionistFn = async (clienteId: any, companiaId: any) => {
    const data = await getReceptionist(
      {clienteId: clienteId || null, companiaId: companiaId || null, isCombo: true},
      1,
      true,
    )
    const allData = [{value: 'CUALQUIERA', label: 'CUALQUIERA'}, ...data]
    setReceptionistComp(allData)
  }

  const handleFilterClient = (e: any, name: string) => {
    let value = e.value
    const {ClienteId} = searchValues
    getReceptionistFn(ClienteId, value)
  }

  const handleFilterSite = (e: any, name: string) => {
    let value = e.value
    const {CompaniaId} = searchValues
    getReceptionistFn(value, CompaniaId)
  }

  const getRooms = async () => {
    try {
      setLoading(true)
      var request = {
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      }
      if (request.LotizacionEmpresaId === 'CUALQUIERA') { request.LotizacionEmpresaId = '' }
      const {data: response} = await getRoomsService(request)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleEditItem = (item: RoomModel) => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,

        detailPanel: 'form-edit-room',
      },
      idToEdit: item.Id,
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  useEffect(() => {
    getCompanyList()
    getLevels()
    getSubStatusRoom()
    getStatusRoom()
    getRoomsType()
    getTypeModulesFn()
    getTurnsFn()
    getClientList()
    getSiteList()
    getCampList()
    getCargosFn()
    return () => {
      clearSearchValues()
    }
    // console.log('me cree rooms')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // setPagination({...pagination, currentPage: 1})
    getRooms()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getRooms()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])

  const columns: Column<RoomModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].Id}
            clickHandler={handleGetId}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro documento compañía'
            name={'CompaniaRuc'}
            searcheable
          />
        ),
        accessor: 'CompaniaRuc',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'CompaniaId'}
            selecteable
            data={compani}
            onGetValueSelect={handleFilterClient}
          />
        ),
        accessor: 'Compania_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro documento cliente'
            name={'ClienteRuc'}
            searcheable
          />
        ),
        accessor: 'ClienteRuc',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            selecteable
            data={client}
            onGetValueSelect={handleFilterSite}
          />
        ),
        accessor: 'Cliente_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name={'SiteId'} selecteable data={site} />
        ),
        accessor: 'Site_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='CampamentoId'
            selecteable
            data={camp}
          />
        ),
        accessor: 'Campamento_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            name={'CodigoModulo'}
            searcheable
          />
        ),
        accessor: 'Modulo_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            name={'TipoModuloId'}
            title='Tipo de Módulo'
            selecteable
            data={typeModules}
          />
        ),
        accessor: 'TipoModulo_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Habitación'
            name={'Codigo'}
            searcheable
          />
        ),
        accessor: 'Codigo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            name={'TipoHabitacionId'}
            title='Tipo de Habitación'
            selecteable
            data={roomType}
          />
        ),
        accessor: 'TipoHabitacion_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            name={'LotizacionEmpresaId'}
            title='Empresa Lotización'
            selecteable
            data={receptionistComp}
          />
        ),
        accessor: 'LotizacionEmpresa_descripcion',
        Cell: ({...props}) => (
          <div>
            {!props.row.original.LotizacionEmpresa_descripcion
              ? 'CUALQUIERA'
              : props.row.original.LotizacionEmpresa_descripcion}
          </div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            name={'TurnoId'}
            title='Turno'
            selecteable
            data={turns}
          />
        ),
        accessor: 'Turno_descripcion',
        Cell: ({...props}) => (
          <div>
            {!props.row.original.Turno_descripcion
              ? 'CUALQUIERA'
              : props.row.original.Turno_descripcion}
          </div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            name={'CargoId'}
            title='Cargo'
            selecteable
            data={cargos}
          />
        ),
        accessor: 'Cargo_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro de Prioridad de Asignación'
            name='PrioridadAsignacion'
            searcheable
            number
          />
        ),
        accessor: 'PrioridadAsignacion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} name={'NivelId'} title='Piso' selecteable data={level} />
        ),
        accessor: 'Nivel_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            name={'EstadoHabitacionId'}
            title='Estado'
            selecteable
            data={statusRoom}
          />
        ),
        accessor: 'EstadoHabitacion_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            name={'SubEstadoHabitacionId'}
            title='Sub Estado'
            selecteable
            data={subStatusRoom}
          />
        ),
        accessor: 'SubEstadoHabitacion_descripcion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) =>
          isAllowed('EDITAR') ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEditItem(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },
    ],
    [
      compani,
      client,
      site,
      camp,
      roomType,
      level,
      statusRoom,
      subStatusRoom,
      typeModules,
      receptionistComp,
      turns,
      cargos,
      selectedOn,
    ],
  )

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    if (currentTabItem.deleted) {
      clearSelected()
      getRooms()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.deleted])

  useEffect(() => {
    if (currentTabItem.updated) {
      clearSelected()
      getRooms()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.updated])

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getRooms()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getRooms()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setReceptionistComp([{value: 'CUALQUIERA', label: 'CUALQUIERA'}])
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  const handleExport = async () => {
    try {
      const response = await getListRoomsExcelService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      })
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Habitaciones-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {}
  }

  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='m-5'>
          {isAllowed('EXPORTAR') && (
            <ButtonWrapper className={'sdx-white-bg'}>
              <Button label='Exportar' onClick={handleExport} disabled={data.length < 1} />
            </ButtonWrapper>
          )}
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableRoomsWrapper = () => {
  const {isAllowed} = useHoteleria()
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Habitaciones</Tab>
            {isAllowed('MASIVO') && <Tab className={'sdx_sub_tab_panel_option'}>Carga Masiva</Tab>}
          </TabList>
          <TabPanel>
            <TableRooms />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <FormMasiveUploadRoom />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableRoomsWrapper}
